<template>
  <section :class="['expandable-item', { 'expandable-item--is-open': isOpen }]">
    <slot name="toggler">
      <h2 class="expandable-item__heading">
        <button class="checkout-section__header" @click="toggleAccordion()">
          {{ header }}

          <oie-use-svg svg="circle-down" :class="{ 'svg--90-negative': isOpen }"></oie-use-svg>
        </button>
      </h2>
    </slot>

    <div class="checkout-section__content" :class="{ 'checkout-section__content--is-open': isOpen }">
      <slot></slot>
    </div>
  </section>
</template>

<script>
import accordionMixin from '@/mixins/accordion.js'

export default {
  mixins: [accordionMixin],
  props: {
    header: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
// .expandable-item {
//   position: relative;
//   padding: 0;
//   background-color: color(background-white);
//   border: 1px solid color(border-gray);
// }

// .expandable-item__toggler {
//   @include reset-button;
//   @include body-semi-bold;
//   position: relative;
//   display: flex;
//   align-items: center;
//   width: 100%;
//   padding: measure(half) ;

//   @include media(medium) {
//     @include h2-semi-bold;
//   }

//   @include media(small) {
//     padding: measure(full) ;
//   }
// }

// .expandable-item__toggler svg {
//   position: absolute;
//   top: 50%;
//   right: measure(half);
//   transform: translateY(-50%);
//   width: 1.875rem;
//   height: 1.875rem;
//   border: none;
//   margin: 0;
//   padding: 0;
//   color: color(gray-2);
//   overflow: hidden;

//   @include media(small) {
//     right: measure(full);
//   }
// }

// .expandable-item__content {
//   display: none;
//   padding: measure(half);

//   @include media(small) {
//     padding: measure(full);
//   }
// }

// .expandable-item--is-open .expandable-item__content {
//   display: flex;
//   flex-direction: column;
// }
</style>
